'use client';
import { useEffect } from 'react';

export function ServiceWorkerRegister() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    navigator.serviceWorker
      .register('/discovery-next-service-worker.js')
      // eslint-disable-next-line no-console
      .then(() => console.debug('SW registered'))
      // eslint-disable-next-line no-console
      .catch(console.error);
  }, []);

  return null;
}
